import { ComponentIds, HierarchyUtils, ProductUtils } from '@inter-ikea-core/core';
import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
export class RestrictLDividerChildrenValidationRule extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'RestrictLDividerChildrenValidationRule');
        this.coreApi = coreApi;
    }
    validateCurrentState(entity) {
        return this.validate(entity);
    }
    validateSnap(snapActionCandidate) {
        return this.validate(snapActionCandidate.guestRoot, snapActionCandidate);
    }
    validate(entity, snapActionCandidate) {
        let parent = snapActionCandidate?.host; // if there is a snap candidate then evaluate the host as parent
        if (!parent) {
            parent = HierarchyUtils.parent(entity); // Otherwise, evaluate where the entity is placed now
            if (!parent) {
                return this.validationOK(); // If no parent exist at all then allow according to this rule (even though that is impossible..)
            }
        }
        if (this.coreApi.entities.isProductType(entity, ProductType.PAX_L_DIVIDER)) {
            const parentCommunicatedSizeWidth = this.getComSizeWidth(parent);
            const originalEntity = entity.getComponent(ComponentIds.AUTO_ADAPT_VARIANT_COMPONENT_ID)?.originalEntity;
            if (parentCommunicatedSizeWidth &&
                parentCommunicatedSizeWidth < 1000.0 &&
                originalEntity &&
                this.lDividerHasChildrenOnOutside(originalEntity)) {
                return this.validationFail('Cannot place L Divider with outside children in a frame with width smaller than 1000mm');
            }
        }
        else if (this.coreApi.entities.isProductType(parent, ProductType.PAX_L_DIVIDER)) {
            if (this.coreApi.entities.isProductType(entity, ProductType.PAX_VALET_HANGER)) {
                return this.validationFail('Cannot place Valet hanger in L Divider');
            }
            else if (this.coreApi.entities.isProductType(entity, ProductType.PAX_PULL_OUT_MULTI_USE_HANGER)) {
                return this.validationFail('Cannot place Multi-use hanger in L Divider');
            }
        }
        return this.validationOK();
    }
    getComSizeWidth(entity) {
        const comSize = entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
        if (comSize == null) {
            /* eslint-disable-next-line no-console */
            console.warn(`Entity ${entity.id} with product ${ProductUtils.productRef(entity)} has no CommunicationSizeComponent. LDividerIn75cmFrameCanNotHave25cmDoorInFrontRule needs to know the size of the entity`);
            return null;
        }
        else {
            return comSize.size.width;
        }
    }
    lDividerHasChildrenOnOutside(entity) {
        const hostConnections = entity.getComponent(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID);
        const foundOutside = hostConnections?.connections.find(connection => this.isLDividerOutsideConnector(connection.hostConnector));
        return foundOutside !== undefined;
    }
    isLDividerOutsideConnector(connector) {
        const hostConnectorKey = connector?.key;
        return (hostConnectorKey !== undefined &&
            hostConnectorKey !== null &&
            (hostConnectorKey?.startsWith('left-outer-holes') ||
                hostConnectorKey?.startsWith('right-outer-holes')));
    }
}
//# sourceMappingURL=RestrictLDividerChildrenValidationRule.js.map